<template>
  <div class="prviwetop" :class="[ show ? 'min-show' : 'min-hide' ]">
    <div class="prviwe" v-show="show">
      <div class="imgtop" id="imgtop" v-drag @mousewheel.prevent="rollImg" >
        <img :class="[ show ? 'imgsrc' : 'imgsrcs']" :src="imgsrc" alt="" ref="imgtop" :style="[ {transform: ` rotate(${ rotateNumber }deg) scale(${ addNumber })`}]">
      </div>
      <img class="blick" src="../assets/icon/blocks.png" title="关闭" alt="关闭" @click="hidefn">
      <img class="leftrotating" src="../assets/icon/left-rotate.png" alt="左旋转" title="左旋转" @click="leftRotatClick">
      <img class="rightrotating" src="../assets/icon/right-rotate.png" title="右旋转" alt="右旋转" @click="rightRotatClick">
      <img class="adding" src="../assets/icon/FD.png" title="放大" alt="放大" @click="addClick">
    </div>
  </div>
</template>

<script>
import config from '../config/confighttp'
export default {

  props: {
    // 是否显示图片预览
    show: {
      type: Boolean,
      default: false
    },
    imgsrc: {
      type: String,
    }
  },
  data: function () {
    return {
      config: null,
      rotateNumber: 0,//旋转角度
      addNumber: 1, //图片放大
    }
  },
  created() {

  },
  directives: {
    drag: {
      inserted: function (el, binding) {
        el.onmousedown = function (e) {
          e.stopPropagation();
          let disx = e.pageX - el.offsetLeft;
          let disy = e.pageY - el.offsetTop;
          document.onmousemove = function (e) {
            e.preventDefault();
            el.style.left = e.pageX - disx + 'px';
            el.style.top = e.pageY - disy + 'px';
          }
          document.onmouseup = function () {
            document.onmousemove = document.onmouseup = null;
            //binding 传参，可忽略
            if (binding && binding.value) {
              binding.value.clientX = parseInt(el.style.left);
              binding.value.clientY = parseInt(el.style.top);
            }

          }
        }
      }
    },
  },
  mounted() {
    this.config = JSON.parse(JSON.stringify(config))
    // config.http_URL+

  },
  methods: {
    // 滚动放大
    rollImg(event) {
      /* 获取当前页面的缩放比 若未设置zoom缩放比，则为默认100%，即1，原图大小 */
      var zoom = parseInt(this.$refs.imgtop.style.zoom) || 100;
      // console.log(this.$refs.imgtop.style.zoom, 'this.$refs.imgtop.style.zoom');
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动 */
      // console.log(zoom,'zoom');
      zoom += event.wheelDelta / 12;
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      // console.log(event.wheelDelta);
      //  console.log(zoom,'zoom2');
      if (zoom >= 80 && zoom < 10000) {
        this.$refs.imgtop.style.zoom = zoom + "%";
      }
      return false;
    },
    // 隐藏
    hidefn() {
      this.$emit('hidefn')
    },
    // 右旋转
    rightRotatClick() {
      this.rotateNumber += 90
    },
    // 左旋转
    leftRotatClick() {
      this.rotateNumber -= 90
    },
    // 放大
    addClick() {
      this.addNumber += 0.6
      if (this.addNumber >= 2) {
        this.addNumber = 1
      }
    }
  },
  watch: {
    show: {
      handler(newVal, oldVal) {
        if (newVal == false) {
          this.addNumber = 1
          this.rotateNumber = 0
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
.prviwetop {
  user-select: none;
  z-index: 3000;

  .imgtop {
    // background-color: red;
    height: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .blick {
    position: absolute;
    width: 30px;
    height: 30px;
    right: 10px;
    top: 49px;
    pointer-events: pointer;
    cursor: pointer;
  }
  .leftrotating {
    position: absolute;
    width: 30px;
    height: 30px;
    right: 100px;
    top: 50px;
    pointer-events: pointer;
    cursor: pointer;
  }
  .rightrotating {
    position: absolute;
    width: 30px;
    height: 30px;
    right: 50px;
    top: 50px;
    pointer-events: pointer;
    cursor: pointer;
  }
  .adding {
    position: absolute;
    width: 22px;
    height: 22px;
    right: 155px;
    top: 53px;
    pointer-events: pointer;
    cursor: pointer;
  }
}
&.min-show {
  background-color: rgba(0, 0, 0, 0.616);
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  left: 0;
  opacity: 1;
  transition: all 0.3s;
}
&.min-hide {
  opacity: 0;
  transition: all 0.3s;
}
.prviwe {
  //   background-color: black;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  left: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 3000;
  .imgsrc {
    // width: 800px;
    height: 566px;
    margin: 35px auto;
    opacity: 1;
    transition: all 0.3s;
  }
  .imgsrcs {
    // width: 800px;
    height: 566px;
    margin: 35px auto;
    opacity: 0;
    transition: all 0.3s;
  }
}
.bg {
  background-color: black;
  opacity: 0.2;
  width: 500px;
  height: 500px;
}
@keyframes show {
  0% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}

@keyframes hide {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0.3;
  }
}
</style>
